'use strict';

var jsxRuntime = require('react/jsx-runtime');

const CardConfirm = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-card_confirm--disabled",
            children: [
                jsxRuntime.jsx("rect", {
                    x: "6",
                    y: "12",
                    width: "42",
                    height: "30",
                    rx: "6",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M27 22H40",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M27 27H40",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M27 32H33",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M12 33V32.6465C12.0782 31.5347 12.6615 28 17.003 28H16.997C21.3385 28 21.9218 31.5283 22 32.6465V33",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M17 26C18.3807 26 19.5 24.8807 19.5 23.5C19.5 22.1193 18.3807 21 17 21C15.6193 21 14.5 22.1193 14.5 23.5C14.5 24.8807 15.6193 26 17 26Z",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "48",
                    cy: "40",
                    r: "8",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M45 39.6L47.25 42L51 38",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-card_confirm",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "6",
                y: "12",
                width: "42",
                height: "30",
                rx: "6",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M27 22H40",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M27 27H40",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M27 32H33",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M12 33V32.6465C12.0782 31.5347 12.6615 28 17.003 28H16.997C21.3385 28 21.9218 31.5283 22 32.6465V33",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M17 26C18.3807 26 19.5 24.8807 19.5 23.5C19.5 22.1193 18.3807 21 17 21C15.6193 21 14.5 22.1193 14.5 23.5C14.5 24.8807 15.6193 26 17 26Z",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("circle", {
                cx: "48",
                cy: "40",
                r: "8",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M45 39.6L47.25 42L51 38",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = CardConfirm;
